import React from 'react';
import PropTypes from 'prop-types';

import { Box } from 'Components/Base';

import StatusCard from '../Components/StatusCard';
import { ContentWrapper } from '../Components/WrapperContent';

const StatusList = ({ data }) => {
  return (
    <>
      <ContentWrapper>
        {data.map((item, index) => {
          const { title, status, loading } = item;
          return (
            <Box key={index}>
              <StatusCard title={title} status={status} loading={loading} />
            </Box>
          );
        })}
      </ContentWrapper>
    </>
  );
};

StatusList.propTypes = {
  data: PropTypes.object,
};

export default StatusList;
